import { Box } from '@mui/material';

const LAPTOP_FRAME_SRC = '/assets/onboarding/welcome-laptop-frame.png';
const WELCOME_SCREEN_SRC = '/assets/onboarding/welcome-laptop-screen.png';
const REASSIGN_SCREEN_SRC = '/assets/onboarding/reassign-laptop-screen.png';
const REASSIGN_SCREEN_SRC_2X = '/assets/onboarding/reassign-laptop-screen@2x.png';
const REASSIGN_SCREEN_WIDTH = 621;
const REASSIGN_SCREEN_HEIGHT = 584;
const REASSIGN_SCREEN_WIDTH_2X = 932;

/** Figma illustration screen insets (646×400 laptop mock). */
const SCREEN_INSET = {
  top: '13.4%',
  right: '13.86%',
  bottom: '13.4%',
  left: '13.86%',
} as const;

function LaptopIllustration({
  screenSrc,
  screenSrcSet,
  screenWidth,
  screenHeight,
  aspectRatio,
}: {
  screenSrc: string;
  screenSrcSet?: string;
  screenWidth?: number;
  screenHeight?: number;
  aspectRatio: string;
}) {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        component="img"
        src={LAPTOP_FRAME_SRC}
        alt=""
        decoding="async"
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          top: SCREEN_INSET.top,
          right: SCREEN_INSET.right,
          bottom: SCREEN_INSET.bottom,
          left: SCREEN_INSET.left,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            aspectRatio,
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src={screenSrc}
            srcSet={screenSrcSet}
            sizes={screenSrcSet ? '100%' : undefined}
            width={screenWidth}
            height={screenHeight}
            alt=""
            decoding="async"
            draggable={screenSrcSet ? false : undefined}
            sx={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              imageRendering: 'auto',
              pointerEvents: 'none',
            }}
          />
        </Box>
      </Box>
    </Box>
  );
}

/** Figma node 16692:5472 — laptop mock with courses screen inset. */
export function OnboardingWelcomeIllustration() {
  return (
    <LaptopIllustration
      screenSrc={WELCOME_SCREEN_SRC}
      aspectRatio="2880 / 1800"
    />
  );
}

/** Figma node 17465:16917 — laptop mock with colleagues screen inset. */
export function OnboardingReassignIllustration() {
  return (
    <LaptopIllustration
      screenSrc={REASSIGN_SCREEN_SRC}
      screenSrcSet={`${REASSIGN_SCREEN_SRC} ${REASSIGN_SCREEN_WIDTH}w, ${REASSIGN_SCREEN_SRC_2X} ${REASSIGN_SCREEN_WIDTH_2X}w`}
      screenWidth={REASSIGN_SCREEN_WIDTH}
      screenHeight={REASSIGN_SCREEN_HEIGHT}
      aspectRatio={`${REASSIGN_SCREEN_WIDTH} / ${REASSIGN_SCREEN_HEIGHT}`}
    />
  );
}
